export enum EApplicationUrls {
  APPLICATION = 'application',
  ANIMALS = 'animals',
  APPROVE = 'approve',
  REJECT = 'reject',
  DETAILS = 'details',
  VERIFY = 'verify',
  RETRACT_REJECTION = 'retract-rejection',
  MOVE_IN = 'move-in',
  RETRACT = 'retract',
  REAPPLY = 'reapply',
  SCREENING = 'screening',
  CONDITIONAL_APPROVED = 'conditional-approved',
  DASHBOARD = 'dashboard',
  ACTION = 'action',
  STATISTICS = 'statistics',
}
